import { Navigate } from 'react-router-dom';
import { useSession } from '@/store/sessionStore';

export function HomeRedirect() {
  const { user } = useSession();
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === 'admin' ? '/admin/rounds' : '/lobby'} replace />;
}
